import type { Icon } from '@/assets/icons'
import type { Entry } from 'contentful'

import type {
  TypeSimulatorSkeleton,
  TypeSimulator_projectSkeleton,
  TypeSimulator_subprojectSkeleton,
} from '~/generated/types'

export type SimulatorType = Entry<TypeSimulatorSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>
export type SimulatorProjectType = Entry<TypeSimulator_projectSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>
export type SimulatorSubProjectType = Entry<TypeSimulator_subprojectSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>

export type SimulatorProjectCardType = {
  id: string
  label: string
  projectType: string
  icon: Icon
}

export type BorrowerType = {
  monthlyAmount: number
  totalAmount: number
  medicalSurvey: boolean
}

export type SimulationProposalType = {
  id: string
  borrowers: BorrowerType[]
  legalNotices: string
  legalNoticesHtml: string
  depositAmount: number
  purchaseAmount: number
  numberOfPayments: number
  scaleId: string
  scaleTypeCode: string
  contractPeriod: number
  annualPercentageRate: number
  nominalRate: number
  fixedBorrowingRate: number
  fees: number
  sellersCost: number
  loanAmount: number
  monthlyPaymentNoInsurance: number
  monthlyPaymentWithInsurance: number
  totalInterestAmount: number
  insuranceAnnualPercentageRate: number
  totalAmountWithInsurance: number
  totalAmountNoInsurance: number
}

export type SimulationResponseType = {
  simulation: SimulationProposalType
  variations?: SimulationProposalType[]
  legalNotice: string
  legalNoticeHtml: string
}

export type ScaleResponseType = {
  creditAmountMax: number
  creditAmountMin: number
  id: string
  numberOfPaymentsMax: number
  numberOfPaymentsMin: number
  productType: string
}

export enum VariationMode {
  duration = 'DURATION',
  amount = 'AMOUNT',
}

export type VariationType = {
  identifier: string
  type: VariationMode
  duration?: number
  amount?: number
}
